module.exports = __webpack_public_path__ + "static/media/SWOOOPTeaser.d58a213d.jpg";